import React from "react";
import {Grid} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ScreenSwitcher} from "./ScreenSwitcher";
import {ScreenPrintListControls} from "./ScreenPrintListControls";
import ScreenSearchContainer from "./ScreenSearchContainer";
import {useSelector} from "react-redux";

const useStyles = makeStyles(theme => ({
    secondRowInHeader: {
        padding: `0 40px`,
        alignItems: `center`,
        // height: `38px`
    },
    screenSwitcherBtnsWrapper: {
        border: `1px solid #E5870E`,
        borderRadius: `6px`,
        // width: `310px`,
    },
}))


export const SecondRowInHeader = (props) => {
    const {contentData} = useSelector(state => state)
    const classes = useStyles();

    return (
        <Grid container className={classes.secondRowInHeader}>
            <Grid item xs={6}>
                <Grid container>
                    <Grid item className={classes.screenSwitcherBtnsWrapper} xs={6}>
                        <ScreenSwitcher getDataForPromos={props.getDataTable} getDataForRegPrices={props.getDataTableForRegularPrices}/>
                    </Grid>
                    {
                        !contentData.isPrintListOpened &&
                        <Grid item xs>
                            <ScreenSearchContainer/>
                        </Grid>
                    }

                </Grid>
            </Grid>
            <Grid item xs>
                <ScreenPrintListControls/>
            </Grid>
        </Grid>
    )
}